<template>
    <div class="main-form">
        <StepNumber
            stepNum = "2"
            totalSteps = "5"
        ></StepNumber>    
        <div class="main-form_info">
            <InputRadioButtons
                :options = "$store.state.inputOptionsVariables.estado_proceso"
                :title = "$store.state.newTexts.step_datos_vivienda[0].title"
                :explanation = "$store.state.newTexts.step_datos_vivienda[0].explanation || ''"
                :selected = "this.$store.state.prescoringData.estado_proceso"
                @valueChanged = "(value) => handleValueChanged('estado_proceso',value)"
            ></InputRadioButtons>
            <InputRadioButtons
                :options = "$store.state.inputOptionsVariables.vivienda_nueva"
                :title = "$store.state.newTexts.step_datos_vivienda[1].title"
                :explanation="$store.state.newTexts.step_datos_vivienda[1].explanation || ''"
                :selected = "this.$store.state.prescoringData.vivienda_nueva"
                @valueChanged = "(value) => handleValueChanged('vivienda_nueva',value)"
            ></InputRadioButtons>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputRadioButtons from '../common/InputRadioButtons.vue'

export default {
    name: 'step_datos_vivienda',
    components: {
        StepNumber,
        NavegationButtons,
        InputRadioButtons
    },
    computed: {
        nextStep(){
            if(this.$store.state.prescoringData.producto === 'habitual') 
                return 'step_datos_hipoteca_habitual';
            if(this.$store.state.prescoringData.producto === '2avivienda')
                return 'step_datos_hipoteca_2avivienda';
            if(this.$store.state.prescoringData.producto === 'inversion')
                return 'step_datos_hipoteca_inversion';
            return false;
        },
        canContinue(){
            const { estado_proceso, vivienda_nueva } = this.$store.state.prescoringData;
            return estado_proceso !== null && estado_proceso !== '' && vivienda_nueva !== null && vivienda_nueva !== '';
        }
    },
    methods: {
        handleValueChanged(field, value){
            this.$store.commit('updatePrescoringData', { field, value });
        }
    }
}
</script>
